import { render, staticRenderFns } from "./ShareMessageContent.vue?vue&type=template&id=38a5d309"
import script from "./ShareMessageContent.vue?vue&type=script&lang=js"
export * from "./ShareMessageContent.vue?vue&type=script&lang=js"
import style0 from "./ShareMessageContent.vue?vue&type=style&index=0&id=38a5d309&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports